import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueToastr2 from 'vue-toastr-2'
import VuejsDialog from 'vuejs-dialog'
import 'jquery'
import 'bootstrap'
import popoverx from 'bootstrap-popover-x'
import 'datatables.net'
import 'datatables.net-bs4'
import storage from '@/store/localstorage.js'
import session from '@/store/sessionStorage.js'
import vSelect from 'vue-select'
import Vuex from 'vuex'

import vuetify from './plugins/vuetify'
import '@babel/polyfill'

import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-select/dist/vue-select.css'

import '@/assets/css/bootstrap.css'
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'
import '@/assets/css/style.css'

import store from '@/store'
import util from '@/common/util'

import http from './http'
import constants from './constants'

import VeeValidate from 'vee-validate'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import VueObserveVisibility from 'vue-observe-visibility'

/**************************
 * Global Methods
 **************************/
import * as InvoiceTools from './inc/invoice-tools'

/**************************
 * CONFIG
 **************************/
import config from './config'

window.$ = require('jquery')
window.jQuery = require('jquery')
window.toastr = require('toastr')
window.base64 = require('jquery-base64')

Vue.use(VueToastr2)
Vue.use(popoverx)
Vue.use(VuejsDialog, { okText: 'はい', cancelText: 'いいえ' })
Vue.use(config)
Vue.use(InvoiceTools)
Vue.use(VueObserveVisibility)
Vue.component('v-select', vSelect)
Vue.use(Vuex)

Vue.config.productionTip = false

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
})

let headerType
router.afterEach((to, from) => {
  if (to.meta && to.meta.headerType) {
    headerType = to.meta.headerType
  }
})

Vue.prototype.$ls = storage
Vue.prototype.$storage = storage
Vue.prototype.$session = session
Vue.prototype.$http = http
Vue.prototype.$const = constants
Vue.prototype.$api_url = config
Vue.prototype.$util = util

store.commit('restoreLanguage')

new Vue({
  router,
  store,
  vuetify,

  render: h => h(App, {
    props: {
      headerType: headerType
    }
  })
}).$mount('#app')
